import { createFileRoute } from '@tanstack/react-router'
import { PlannerListPage } from '@/components/planner/planner-list-page'

export const Route = createFileRoute('/plans')({ component: PlannerListPage })
